import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// Admin routes require a valid admin session. The admin session is stored under
// its own credential (admin-token) so a user/target token can never satisfy it.
export default function RequireAuth() {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
